module.exports = __webpack_public_path__ + "static/media/open-magazine.bb1411c9.svg";